import { BaseAnswer } from "../interfaces/answer";
import { Task } from "../interfaces/task";
import { TaskItemResponseElement } from "../interfaces/task-item-response-element";

export function normalizeTask(task: Task) {
    const exampleTaskItem = task.items.find((item) => item.isExample) ?? null;
    const notExampleItems = task.items.filter((item) => !item.isExample);
    const mustStartIndex = notExampleItems.findIndex((item) => item.id === task.mustStartItemId);

    return {
        activeTask: {
            ...task,
            items: notExampleItems,
        },
        exampleTaskItem,
        isExampleTaskActive: !!exampleTaskItem,
        taskItemIndex: mustStartIndex >= 0 ? mustStartIndex : -1,
    };
}

export function buildAnswerContent(answers: TaskItemResponseElement[]): string {
    return answers.map((x) => x.answer).join(',');
}

export function buildBaseAnswer(
    params: {
        answers: TaskItemResponseElement[];
        taskResultId: number;
        taskItemId: number;
        isAttempt: boolean;
        duration?: number;
        resetLastActiveItemDuration?: boolean;
        isLastItem: boolean;
    }
): BaseAnswer {
    return {
        taskResultId: params.taskResultId,
        taskItemId: params.taskItemId,
        content: buildAnswerContent(params.answers),
        isCorrect: params.answers.length > 0 && params.answers.every((x) => x.isCorrect),
        isLast: !params.isAttempt && params.isLastItem,
        duration: params.duration,
        resetLastActiveItemDuration: params.resetLastActiveItemDuration ?? false,
    };
}